import { AccordionStateType, } from '@kubit/web-ui-components/accordionV2';
import { AccordionVariantTypeV2 as AccordionVariantType } from '../../../../../../components/accordionV2/types/accordionVariantType';
import { commonStyles } from '../commonStyles';
const commonStateStyles = (FOUNDATIONS) => {
    return {
        rootContainer: {
            background_color: FOUNDATIONS.color_comp_containers_accordion_standard_bg,
        },
    };
};
export const getStandardStyles = (FOUNDATIONS, FONT) => {
    return {
        [AccordionVariantType.STANDARD]: {
            [AccordionStateType.COLLAPSED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    ...commonStateStyles(FOUNDATIONS),
                    content: {
                        grid_template_rows: '0fr',
                        // There is a transition in commonStyles for these padding values (so there is not a jump when collapsing)
                        padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_00}`,
                    },
                }),
            },
            [AccordionStateType.EXPANDED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    ...commonStateStyles(FOUNDATIONS),
                }),
            },
        },
    };
};
//# sourceMappingURL=standard.js.map